import getCaretCoordinates from 'textarea-caret';
import insertText from './insertText';
import ItemList from './ItemList';
import type EditorDriverInterface from './EditorDriverInterface';
import { type EditorDriverParams } from './EditorDriverInterface';

export default class BasicEditorDriver implements EditorDriverInterface {
  el: HTMLDivElement;

  constructor(dom: HTMLElement, params: EditorDriverParams) {
    this.el = document.createElement('div');
    this.el.setAttribute('id', 'myTextarea');
    this.build(dom, params);
  }

  protected build(dom: HTMLElement, params: EditorDriverParams) {
    this.el.className = params.classNames.join(' ');
    // this.el.disabled = params.disabled;
    // this.el.placeholder = params.placeholder;
    // this.el.value = params.value;
    this.el.innerHTML = params.value;
    this.el.contentEditable = 'true';

    const callInputListeners = (e: Event) => {
      params.inputListeners.forEach((listener) => {
        listener();
      });

      e.redraw = false;
    };

    this.el.oninput = (e) => {
      params.oninput(this.el.innerHTML);
      callInputListeners(e);
    };

    this.el.onclick = callInputListeners;
    this.el.onkeyup = callInputListeners;

    this.el.addEventListener('keydown', (e) => {
      this.keyHandlers(params)
        .toArray()
        .forEach((handler) => handler(e));
    });

    dom.append(this.el);
  }

  protected keyHandlers(params: EditorDriverParams) {
    const items = new ItemList<(e: KeyboardEvent) => void>();

    items.add('submit', function (e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
        params.onsubmit();
      }
    });

    return items;
  }

  moveCursorTo(position: number) {
    this.setSelectionRange(position, position);
  }

  getSelectionRange(): Array<number> {
    return [this.el.selectionStart, this.el.selectionEnd];
  }

  getLastNChars(n: number): string {
    const value = this.el.value;

    return value.slice(Math.max(0, this.el.selectionStart - n), this.el.selectionStart);
  }

  insertAtCursor(text: string) {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0); // 获取当前选区范围
      let startIndex = range.startOffset;
      this.insertAt(startIndex, text);
    } else{
      this.insertAt(this.el.selectionStart, text);
    }
  }

  insertAt(pos: number, text: string) {
    this.insertBetween(pos, pos, text);
  }

  insertBetween(selectionStart: number, selectionEnd: number, text: string) {
    this.setSelectionRange(selectionStart, selectionEnd);
    let cursorPos = selectionStart + text.length;
    if (text.indexOf("[upl-image-preview") !== -1) {
      cursorPos = selectionStart
    }else{
      cursorPos = selectionStart + text.length;
    }

    insertText(this.el, { text, selectionStart: cursorPos, selectionEnd: cursorPos });
  }

  replaceBeforeCursor(start: number, text: string) {
    this.insertBetween(start, this.el.selectionStart, text);
  }

  protected setSelectionRange(start: number, end: number) {
    this.setSelectionRangeInDiv(this.el, start, end);
    // this.el.setSelectionRange(start, end);
    this.focus();
  }

  getCaretCoordinates(position: number) {
    const relCoords = getCaretCoordinates(this.el, position);

    return {
      top: relCoords.top - this.el.scrollTop,
      left: relCoords.left,
    };
  }

  // DOM Interactions

  /**
   * Set the disabled status of the editor.
   */
  disabled(disabled: boolean) {
    this.el.disabled = disabled;
  }

  /**
   * Focus on the editor.
   */
  focus() {
    this.el.focus();
  }

  /**
   * Destroy the editor
   */
  destroy() {
    this.el.remove();
  }
  setSelectionRangeInDiv(div: HTMLDivElement, startOffset: number, endOffset: number) {
    // // 创建一个Range对象
    // const range = document.createRange();
    // // 获取div的第一个孩子元素，因为我们是在可编辑的div中操作
    // const firstChild = div.firstChild as Text | Node;
    // if (firstChild === null) {
    //   return;
    // }
    // // 设置Range的边界
    // range.setStart(firstChild, startOffset);
    // range.setEnd(firstChild, endOffset);

    // // 清除现有的选区
    // const selection = window.getSelection();
    // selection.removeAllRanges();

    // // 添加新的选区
    // selection.addRange(range);

    // // 将焦点设置到div上，确保选区可见
    // div.focus();
    if (!div.contentEditable) {
      console.error('The div should have contenteditable attribute set to true');
      return;
    }

    // 获取div的所有子节点（假设最后一个子节点包含最终文本）
    const lastChild = div.lastChild as Text | null;

    if (lastChild && lastChild.nodeType === Node.TEXT_NODE) {
      // 创建一个Range对象
      const range = document.createRange();

      // 设置Range的边界，使其位于文本节点的末尾
      range.selectNodeContents(lastChild);
      range.collapse(false); // 参数false表示将光标置于范围的结束位置，即内容末尾

      // 清除现有的选区
      const selection = window.getSelection();
      selection.removeAllRanges();

      // 添加新的选区
      selection.addRange(range);

      // 将焦点设置到div上，确保选区可见
      div.focus();
    }
  }
}
